import Client from '../client';
import shareLogic from './logic';
import loadScript from '../../util/loadscript';
export default class H5Share {
  constructor(config) {
    this.config = config;
  }
  async share(config = {}) {
    const _config = {
      ...this.config,
      ...config,
    };
    if (Client.isWindVane() && (Client.isAliyunApp() || Client.isTaobao())) {
      // 阿里云APP 使用APP分享
      await shareLogic.appShare(_config);
    } else if (Client.isWeixin()) {
      // 微信里面，使用浮层分享
      shareLogic.wxShare(this.dom, _config);
    } else {
      // 浏览器环境，使用蒙层分享
      shareLogic.browserShare(this.dom, _config);
    }
  }
  /**
   * 根据各个渠道，预置一些DOM到文档里
   * @param {object} config 配置
   */
  async setupView() {
    return new Promise(resolve => {
      if (Client.isWindVane() && (Client.isAliyunApp() || Client.isTaobao())) {
        // 阿里云APP 在windvane引入的情况下，使用APP分享
        resolve();
      } else if (Client.isWeixin()) {
        // 微信里面，使用浮层分享
        const dom = `<div class="share-bar-wrapper share-bar-bottom">
          <div class="share-bar-bottom-mask">
          <p class="top-info">点击右上角<br/>分享到朋友圈及好友~</p>
          <div class="top-arrow"></div>
          </div>
          </div>`;
        const $dom = $(dom);
        $('body').append($dom);
        this.dom = $dom;
        $dom.find('.share-bar-bottom-mask').on('click', function() {
          $dom.remove();
        });
        // 加载微信JSSDK
        loadScript('https://res2.wx.qq.com/open/js/jweixin-1.4.0.js').then(() => {
          if (!window.appId || !window.wx) {
            console.error('error: 微信分享页面路径必须渲染微信分享配置信息');
            return;
          }
          window.wx.config({
            appId: window.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: window.timestamp, // 必填，生成签名的时间戳
            nonceStr: window.nonceStr, // 必填，生成签名的随机串
            signature: window.signature, // 必填，签名，见附录1
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareQZone',
              'updateAppMessageShareData',
              'updateTimelineShareData',
            ],
          });
          window.wx.ready(function() {
            resolve();
          });
          window.wx.error(function() {
            resolve();
          });
        });
      } else {
        // 浏览器环境，使用蒙层分享
        const dom =
          '<div class="share-bar-wrapper share-bar-bottom">' +
          '<div class="share-container share-fixed">' +
          '<p class="share-title">请选择分享方式</p>' +
          '<ul class="share-list clearfix"></ul>' +
          '</div>' +
          '<div class="share-bar-bottom-mask"></div>' +
          '</div>';
        const $dom = $(dom);
        $('body').append($dom);
        this.dom = $dom;
        resolve();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/share/h5.js